module.exports = __webpack_public_path__ + "media/ВаняДмитриенко-JinXingMuXing.9722fe27.mp3";